import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import VideoSection from "./components/VideoSection";
import MissionSection from "./components/MissionSection";
import ServicesSection from "./components/ServicesSection";
import PartnersSection from "./components/PartnersSection";
import ClientsSection from "./components/ClientsSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <VideoSection />
        <MissionSection />
        <ServicesSection />
        <PartnersSection />
        <ClientsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
